import React, { useRef } from 'react'
import styles from './BestPractice.module.scss'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'

const BestPractice: React.FC = () => {
  const animeRef = useRef<HTMLDivElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)

  return (
    <section
      className={`${styles.best__practice} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      <div className={styles.inner}>
        <h2 className={styles.bp__title}>
          ZEBRAはプッシュ通知を求める企業に
          <br />
          最適なSaaS・ソリューションです
        </h2>
        <div className={styles.bp__cts}>
          <figure className={styles.bp__cts__image}>
            <img
              src="/img/LP/zebra/zebra_mockup.webp"
              alt="ZEBRAはプッシュ通知を求める企業に最適なSaaS・ソリューションです"
              width={520}
              height={301}
            />
          </figure>
          <div className={styles.bp__cts__wrapper}>
            <p className={styles.bp__cts__wrapper__text}>
              ZEBRAは、顧客属性DBを活用した高度なセグメント配信を実現します。全件配信、セグメント配信、リスト配信など多彩な配信方法を提供し、顧客のニーズに合わせた最適なメッセージを届けることが可能です。当社の専門家チームが、お客さまのニーズに合わせた最適なZEBRA環境の設計から運用までをトータルでサポートします。
            </p>
            <dl className={styles.bp__cts__wrapper__box}>
              <dt className={styles.bp__cts__wrapper__box__title}>プッシュ通知とは</dt>
              <dd className={styles.bp__cts__wrapper__box__text}>
                プッシュ通知とは、アプリやウェブサービスからユーザー端末に直接送られる通知のことです。ユーザーがアプリを開いていなくてもサーバーから自動的に配信され、最新情報やお知らせをタイムリーに届けることができます。
              </dd>
            </dl>
          </div>
        </div>
      </div>
    </section>
  )
}
export default BestPractice
